// Lectura del sello propio: quien soy yo, el bundle que esta corriendo.
//
// La app NO lleva su buildId compilado adentro. No podria: el id es el hash
// del bundle, que no existe cuando se transpila el codigo. Lo lee de los
// <meta> del HTML con el que fue servida (los inyecta el plugin de Vite en
// closeBundle). Eso ademas lo hace exacto: identifica al documento que trajo
// estos assets, que es justo lo que queremos comparar.

import type { LocalStamp } from './types';

function meta(name: string): string | null {
  const el = document.querySelector(`meta[name="authsys-${name}"]`);
  const content = el?.getAttribute('content');
  return content && content.length > 0 ? content : null;
}

let cached: LocalStamp | null = null;

export function readLocalStamp(): LocalStamp {
  if (cached) return cached;

  const dirty = meta('dirty');
  cached = {
    // 'unknown' solo puede pasar si alguien sirve un index.html que no paso
    // por el plugin. El guard lo trata como "no puedo comparar" y no molesta
    // al usuario, en vez de gritar update en cada chequeo.
    buildId: meta('build') ?? 'unknown',
    commitShort: meta('commit'),
    commitDate: meta('commit-date'),
    builtAt: meta('built-at'),
    portal: meta('portal'),
    dirty: dirty === null ? null : dirty === 'true',
  };
  return cached;
}

/** Los assets que este documento cargo — huella de respaldo del bundle. */
export function currentAssetFingerprint(): string {
  const urls: string[] = [];
  for (const el of document.querySelectorAll<HTMLScriptElement>('script[src]')) {
    urls.push(el.getAttribute('src') ?? '');
  }
  for (const el of document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"][href]')) {
    urls.push(el.getAttribute('href') ?? '');
  }
  return urls.filter(Boolean).sort().join('|');
}
